import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from 'app/services/services.index';

import { Router } from '@angular/router';
import { AppCore } from 'app/app.core';
import { Subscription } from 'rxjs';

@Injectable()
export class LoginGuard extends AppCore implements CanActivate {

  private usuario: any;
  private endChecktokenSubscription: Subscription;

  constructor(
    private _auth: AuthService,
    private _router: Router
  ) {
    super();
  }

  canActivate() {
    this.usuario = this._auth.getUser();

    if (!this.usuario) {
      this.setMensaje('Acceso denegado', 'Usuario no autentificado', 'error');
      this._router.navigate(['/login']);
      return false;
    }

    let token = localStorage.getItem('token');
    this.endChecktokenSubscription = this._auth.checkToken(token).subscribe(
      res => {
        if (!res.data) {
          this.setMensaje('Error', res.message, 'error');
          this._router.navigate(['/login']);
          this.endChecktokenSubscription.unsubscribe();
          return false;
        }
        this.endChecktokenSubscription.unsubscribe();
        return true;
      }, error => {
        this.setMensaje('Error de conexion', 'No se ha podido establecer la conexion', 'error');
        this._router.navigate(['/login']);
        this.endChecktokenSubscription.unsubscribe();
        return false;
      });
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/login.guard.ts